import React from 'react'
import { Link, useHistory } from "react-router-dom"
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  // Checkbox
} from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { useAuth } from '../../contexts/AuthContext'

const Login = () => {
  const { passwordResetEmail } = useAuth()
  const history = useHistory()

  const onFinish = (values) => {
    passwordResetEmail(values.email)
      .then(user => {
        history.push("/auth/login")
      })
    // console.log('Success:', values)
  }

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }

  return (
    <Row justify="center">
      <Col span={24} lg={{ span: 7 }}>
        <div className="form-container">
          <div className="form-header">
            <h1>Forgot assword</h1>
            <p>Enter your email to get password reset link</p>
          </div>
          <Form
            name="forgot_pass"
            className="login-form"
            // initialValues={{ remember: true }}
            size="large"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              name="email"
              rules={[
                {
                  required: true, message: 'E-mail is required!'
                },
                {
                  type: 'email', message: 'Please enter valid E-mail!',
                }
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Email"
              />
            </Form.Item>
            <Form.Item className="mt-2">
              <Button type="primary" htmlType="submit">
                Submit
              </Button>

              <span className="form-link-right ant-btn-lg">
                Back to <Link to="/auth/login">Log In</Link>
              </span>
            </Form.Item>
          </Form>
        </div>
      </Col>
    </Row>
  )
}

export default Login
